import { useEffect, useState, useRef } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography, Button } from "@albo-ui/core";
import { Box, MenuItem, TextField, Select, FormControl, InputLabel, InputAdornment } from "@mui/material";
import { CreateNewFolder, AddBusiness, SaveAs } from "@mui/icons-material";
import { useCRMAddRegister } from "./hooks/useCRMAddRegister";

export const CRMCreateRegister = ({ changeAlert, changeLoader, sectionData, platformData, platformInfo, formSelected, selectedSection, open, onClose, catalogs, getData, crmType, getLeadByUuid, crmContactFlow }: any) => {
    const { loading: loadingTable, form, tabActive, zPos, isValid, error, companyGroups, segments, storeData, onHandleChange, cleanForm, onCreate, onUpdate } = useCRMAddRegister(changeAlert, onClose, getData, getLeadByUuid, crmContactFlow)
    const [ search, setSearch ] = useState<any>("");
    const searchInputRef = useRef<HTMLInputElement | null>(null);
    const crmAdmin = localStorage.config && JSON.parse(localStorage.config)["crmAdmin"] ? JSON.parse(localStorage.config)["crmAdmin"] : false;

    useEffect(() => {
        open ? storeData(selectedSection, sectionData, crmType, platformData, platformInfo) : cleanForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    useEffect(() => {
        changeLoader(loadingTable);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);

    const onCloseDialog = async () => {
        await cleanForm();
        return onClose();
    };

    const filteredOptions = companyGroups?.filter(({ group_name }) =>
        group_name.toLowerCase().includes(search.toLowerCase())
    );
    
    const showFields = (prop1, prop2, label, aux_label = null, required, select = null) => {
        if (select || prop2 === "company_group" || prop2 === "segment") {
            return (
                <FormControl variant="standard" fullWidth key={`${prop1}-${prop2}`} required={required} sx={{maxWidth: "245px"}}>
                    <InputLabel>{`${label} ${aux_label ? aux_label : ""}`}</InputLabel>
                    <Select label={`${label} ${aux_label ? aux_label : ""}`} value={form[prop2] || (form[prop1] && form[prop1][prop2]) || -1} onChange={onHandleChange.bind(this, prop1, prop2, null)} color="secondary" sx={{mb: 2}} inputProps={{ shrink: "true" }} fullWidth variant="standard" displayEmpty
                        MenuProps={{
                            style: {zIndex: 35001},
                            PaperProps: {
                                style: { maxHeight: 300, overflowY: "auto" },
                            },
                        }}
                    >
                        { prop1 && prop2 === "company_group" && <MenuItem disableRipple>
                            <TextField
                                inputRef={searchInputRef}
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setTimeout(() => searchInputRef.current?.focus(), 0);
                                }}
                                onClick={(e) => e.stopPropagation()}
                                onKeyDown={(e) => e.stopPropagation()}
                                variant="outlined" placeholder="Buscar..." fullWidth size="small" autoFocus
                            />
                        </MenuItem>}
                        { prop1 && prop2 === "company_group" && form[prop1] && form[prop1][prop2] && companyGroups.length > 0 && (companyGroups?.filter((company) => company.uuid === form[prop1][prop2]).length === 0) ? 
                            <MenuItem color="error" value={form[prop1][prop2]} disabled>
                                <span style={{ color: "red" }}>{`Grupo Inválido: ${form[prop1][prop2]}`}</span>
                            </MenuItem>
                            :
                            <MenuItem value={-1} disabled>Seleccione</MenuItem>
                        }
                        {platformData && prop2 === "company_group" && 
                            <MenuItem value={''}>No aplica</MenuItem>
                        }
                        {platformData && prop2 === "company_group" ? filteredOptions?.map((item) => (
                                <MenuItem key={`${prop1}-${prop2}-${item.uuid}`} value={item.uuid}>
                                    {item.group_name}
                                </MenuItem>
                            ))
                            :
                            platformData && prop2 === "segment" ? segments?.map((item) => (
                                <MenuItem key={`${prop1}-${prop2}-${item.k}`} value={item.k}>
                                    {item.v}
                                </MenuItem>
                            ))
                            :
                            platformData[select]?.map((item) => (
                                <MenuItem key={`${prop1}-${prop2}-${item.key}`} value={item.key}>
                                    {item.label}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>

            );
        } else if (prop2.includes("phone") && form) {
            return (
                <Box display={"flex"} key={`phone-${prop1}-${prop2}`}>
                    <FormControl variant="standard" fullWidth sx={{width: "55%", mr: 1}} required={required}>
                        <InputLabel>Código</InputLabel>
                        <Select value={form[prop1] && form[prop1][prop2] ? form[prop1][prop2]["phone_code"].substring(1) : "52"} onChange={onHandleChange.bind(this, prop1, prop2, "phone_code")} color="secondary" MenuProps={{style: {zIndex: 35001}}} sx={{mb: 2, mt: "9px !important"}} inputProps={{ shrink: "true" }} fullWidth variant="standard">
                            {catalogs?.map((item, index) => (
                                <MenuItem key={`country-${index}`} value={item.m[0].dial}>
                                    (+{item.m[0].dial}) {item.m[0].code2}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField value={(form[prop1] && form[prop1][prop2] && form[prop1][prop2]["phone"]) || ""} onChange={onHandleChange.bind(this, prop1, prop2, "phone")} label={`${label} ${aux_label ? aux_label : ""}`} size="small" color="secondary" variant="standard" sx={{ mb: 2 }} fullWidth InputLabelProps={{ shrink: true }} required={required}/>
                </Box>
            );
        } else {
            return <TextField key={`${prop1}-${prop2}`} required={required} disabled={prop2 === "charge_fee" && (crmAdmin ? false : ((form["general"] && form["general"]["company_group"]) || form["low_funnel"] === "won_opportunity")) ? true : false} type={prop2 === "charge_fee" ? "number" : "string"}
            InputProps={{endAdornment: prop2 === "charge_fee" && <InputAdornment position="end">%</InputAdornment>}}
            value={
                prop2 && form[prop1] ? form[prop1][prop2] || "" :
                prop1 ? form[prop1] || "" : 
                form[prop2] || ''
            } onChange={onHandleChange.bind(this, prop1, prop2, null)} label={`${label} ${aux_label ? aux_label : ""}`} size='small' color='secondary' variant='standard' sx={{mb: 2}} fullWidth InputLabelProps={{ shrink: true }}/>
        }
    };

    const validateType = () => {
        switch (selectedSection+"|"+tabActive) {
            case "company|create":
                return <>
                    <CreateNewFolder sx={{ marginRight: 2 }} color="primary" fontSize="large"/>
                    <Typography variant='h2' style={{fontSize: '1.2rem'}}>Crear empresa</Typography>
                </>
            case "company|update":
                return <>
                    <AddBusiness sx={{ marginRight: 2 }} color="primary" fontSize="large"/>
                    <Typography variant='h2' style={{fontSize: '1.2rem'}}>Actualizar empresa</Typography>
                </>
            case "contact|create":
                return <>
                    <CreateNewFolder sx={{ marginRight: 2 }} color="primary" fontSize="large"/>
                    <Typography variant='h2' style={{fontSize: '1.2rem'}}>Crear contacto</Typography>
                </>
            case "contact|update":
                return <>
                    <AddBusiness sx={{ marginRight: 2 }} color="primary" fontSize="large"/>
                    <Typography variant='h2' style={{fontSize: '1.2rem'}}>Actualizar contacto</Typography>
                </>
            case "company_group|create":
                return <>
                    <CreateNewFolder sx={{ marginRight: 2 }} color="primary" fontSize="large"/>
                    <Typography variant='h2' style={{fontSize: '1.2rem'}}>Crear Grupo de Empresas</Typography>
                </>
            case "company_group|update":
                return <>
                    <SaveAs sx={{ marginRight: 2 }} color="primary" fontSize="large"/>
                    <Typography variant='h2' style={{fontSize: '1.2rem'}}>Actualizar Grupo de Empresas</Typography>
                </>
        }
    };

    let test = [];

    const getField = (init, i) => {
        let test2 = 1;
        return <FlexGrid key={i} container spacing={2} fullWidth fullHeight justify="space-between">
        {init < 3 && formSelected?.map((obj, j) => {
            init++
            if(test.indexOf(j)  === -1 && test2 < 3 && !obj["text"]){
                test.push(j)
                test2++
                return <FlexGrid key={j} item fullWidth>
                    {obj["prop"] ? showFields(obj["prop"], obj["key"], obj["label"], obj["aux_label"], obj["required"]) : showFields(obj["section"], obj["key"], obj["label"], obj["aux_label"], obj["required"], obj["catalog"] )}
                </FlexGrid>
            }
            return null;
        })}
        </FlexGrid>
    }

    return (
        <Dialog onClose={onClose} open={open} style={{ display: zPos !== 45 ? "none" : null, minWidth: 600, maxHeight: 500 }}>
            <DialogTitle>
                <Box display={"flex"} alignItems={"center"} mb={2}>{validateType()}</Box>
			</DialogTitle>
            <DialogContent>
                {open && !loadingTable && formSelected?.map((obj1, i) => {
                    let init = 1;
                    return i % 2 === 0 && getField(init, i)
                })}
                {selectedSection !== "company_group" && 
                    <FlexGrid container spacing={2} fullWidth fullHeight justify="space-between">
                        <FormControl variant="standard" fullWidth required>
                            <InputLabel>Origen (Obligatorio)</InputLabel>
                            <Select value={form['origin_platform'] || '-1'} onChange={onHandleChange.bind(this, "origin_platform", "", "" )} color="secondary" MenuProps={{style: {zIndex: 35001}}} sx={{mb: 2}} fullWidth variant="standard" >
                                <MenuItem value={"-1"} disabled>Seleccione</MenuItem>
                                {platformData && platformData['origin_platform']?.map((item, index) => {
                                    return <MenuItem key={`option-${index}`} value={item.key}>{item.label}</MenuItem>
                                })}
                            </Select>
                        </FormControl>

                        {selectedSection === "contact" && <FormControl variant="standard" fullWidth required>
                            <InputLabel>Estatus (Obligatorio)</InputLabel>
                            <Select value={form['status'] || '-1'} onChange={onHandleChange.bind(this, "status", "", "")} color="secondary" MenuProps={{style: {zIndex: 35001}}} sx={{mb: 2}} fullWidth variant="standard">
                                <MenuItem value={"-1"} disabled>Seleccione</MenuItem>
                                {platformData && platformData['contactStatus']?.map((item, index) => {
                                    return <MenuItem key={`option-${index}`} value={item.key}>{item.label}</MenuItem>
                                })}
                            </Select>
                        </FormControl>}

                    </FlexGrid>
                }
                {error && <Typography variant="small" color="required">{error}</Typography>}
            </DialogContent>

            <DialogActions>
                <FlexGrid container fullHeight fullWidth justify="space-between" alignItems="flex-end" style={{ marginTop: 10 }}>
                    <FlexGrid item>
                        <Button onClick={onCloseDialog} buttonType="secondary" size="normal">Cancelar</Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button onClick={sectionData ? onUpdate : onCreate} disabled={isValid} size="normal" >Aceptar</Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    );
};
